import {
  getStoreHealthChartDataPending,
  getStoreHealthChartDataSuccess,
  getStoreHealthChartDataError,
} from './index';
import config from '../../oktaConfig';

function getStoreHealthChartData(accessToken, siteId) {
  return dispatch => {
    dispatch(getStoreHealthChartDataPending());

    fetch(`${config.resourceServer.insightsApiUrlStoreHealthChartData}?siteid=${siteId}`, {
      mode: 'cors',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(
            new Error(
              `Failed to fetch store health chart data: ${response.status} ${response.statusText}`
            )
          );
        }
        return response.json();
      })
      .then(data => {
        dispatch(getStoreHealthChartDataSuccess(data));
      })
      .catch(err => {
        dispatch(getStoreHealthChartDataError(err));
        /* eslint-disable no-console */
        console.error('Unable to retrieve store health chart data', err);
      });
  };
}

export default getStoreHealthChartData;
